import ListMap from '../core/ListMap';
import MetaQueryField from './MetaQueryField';

class MetaQueryFieldList extends ListMap {
  constructor(args = {}) {
    const {
      data = [],
    } = args;

    super({ ...args, data: data.map(v => new MetaQueryField({ ...args, data: v })) });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  constructItem(key) {
    return new MetaQueryField({ data: { name: key } });
  }
}

export default MetaQueryFieldList;
